import { DateTime } from "luxon";

export function startOfLocalDay(d: Date): Date {
  return DateTime.fromJSDate(d).startOf("day").toJSDate();
}
